import { render, staticRenderFns } from "./SchoolWasGardenPage.vue?vue&type=template&id=64420171&scoped=true"
import script from "./SchoolWasGardenPage.vue?vue&type=script&lang=js"
export * from "./SchoolWasGardenPage.vue?vue&type=script&lang=js"
import style0 from "./SchoolWasGardenPage.vue?vue&type=style&index=0&id=64420171&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64420171",
  null
  
)

export default component.exports